import {
  useDeleteExternalAction as originalDeleteMutation,
  useGetAllExternalActions as originalGetAllActionsMutation,
  useRejectExternalAction as originalRejectMutation,
  useRunExternalAction as originalRunMutation,
} from "../services/AtomAssistActions";

// Re-export your original hooks directly to maintain the existing implementation
export const useGetAllExternalActions = originalGetAllActionsMutation;
export const useDeleteExternalAction = originalDeleteMutation;
export const useRunExternalAction = originalRunMutation;
export const useRejectExternalAction = originalRejectMutation;
